/* TC32 · Imágenes por variante (reemplaza Rubik Variant Images)
   Lee el mapa variante → fotos que imprime el tema en #tc32-vmedia
   y muestra solo las fotos de la variante elegida en la galería y en las miniaturas. */
(function () {
  var data = document.getElementById('tc32-vmedia');
  if (!data) return;
  var map;
  try { map = JSON.parse(data.textContent) || {}; } catch (e) { return; }
  if (!Object.keys(map).length) return;

  var css = document.createElement('style');
  css.textContent = '.tc32-vm-hide{display:none!important}';
  document.head.appendChild(css);

  function mid(str) { return String(str || '').split('-').pop(); }

  function currentVariant() {
    var u = new URLSearchParams(location.search).get('variant');
    if (u) return u;
    var input = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value;
  }

  function apply(vid) {
    var ids = map[String(vid)];
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var list = g.querySelector('.product__media-list');
      var thumbs = g.querySelector('.thumbnail-list');
      var items = list ? Array.prototype.slice.call(list.querySelectorAll(':scope > li[data-media-id]')) : [];
      var tItems = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll(':scope > li[data-target]')) : [];

      if (!ids || !ids.length) {
        items.concat(tItems).forEach(function (li) { li.classList.remove('tc32-vm-hide'); });
        return;
      }
      var keep = {};
      ids.forEach(function (id) { keep[String(id)] = true; });

      items.forEach(function (li) { li.classList.toggle('tc32-vm-hide', !keep[mid(li.dataset.mediaId)]); });
      tItems.forEach(function (li) { li.classList.toggle('tc32-vm-hide', !keep[mid(li.dataset.target)]); });

      ids.forEach(function (id) {
        var li = items.find(function (x) { return mid(x.dataset.mediaId) === String(id); });
        if (li) list.appendChild(li);
        var t = tItems.find(function (x) { return mid(x.dataset.target) === String(id); });
        if (t && thumbs) thumbs.appendChild(t);
      });
      items.forEach(function (li) { if (li.classList.contains('tc32-vm-hide')) list.appendChild(li); });
      tItems.forEach(function (li) { if (li.classList.contains('tc32-vm-hide')) thumbs.appendChild(li); });

      var first = items.find(function (x) { return mid(x.dataset.mediaId) === String(ids[0]); });
      if (first && typeof g.setActiveMedia === 'function') {
        try { g.setActiveMedia(first.dataset.mediaId, false); } catch (e) {}
      }
      g.querySelectorAll('slider-component').forEach(function (s) {
        if (typeof s.initPages === 'function') { try { s.initPages(); } catch (e) {} }
        if (typeof s.resetPages === 'function') { try { s.resetPages(); } catch (e) {} }
      });
      list.scrollLeft = 0;
    });

    document.querySelectorAll('.product-media-modal__content').forEach(function (m) {
      if (!ids || !ids.length) return;
      var keep = {};
      ids.forEach(function (id) { keep[String(id)] = true; });
      m.querySelectorAll('[data-media-id]').forEach(function (el) {
        el.classList.toggle('tc32-vm-hide', !keep[mid(el.dataset.mediaId)]);
      });
    });
  }

  function run() { apply(currentVariant()); }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      apply(v ? v.id : currentVariant());
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') setTimeout(run, 0);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();
